import react, {useEffect, useState} from "react";
import useToken from "../useToken";
import { useParams, Link } from "react-router-dom";




export default function ContactsSelectable(){
    const[contacts, setContacts] = useState([]);
    const token = useToken();
    let params = useParams();
    let account_id='';
    if (params.id!=undefined)
        account_id = params.id;

    useEffect(()=>{
        let URL='';
        if (account_id=='')
            URL = process.env.NODE_ENV === 'development' ? `${process.env.REACT_APP_API_URL_DEV_MODE}api/contacts/`: `${process.env.REACT_APP_API_URL_PROD_MODE}api/contacts/`;
        else
            URL = process.env.NODE_ENV === 'development' ? `${process.env.REACT_APP_API_URL_DEV_MODE}api/contacts/${account_id}/`: `${process.env.REACT_APP_API_URL_PROD_MODE}api/contacts/${account_id}/`;
        
        
        console.log(URL)
        //fetch(URL, {headers: {"Authorization" :  `Token ${token}`}})
        fetch(URL, {headers: {"Authorization" :  `Token ${token}`}})
        .then((res) => res.json())
        .then((data)=>{
            setContacts(()=>[...data]);

        })
        .catch(error=> console.log(error))

    }, []);

    // Now return contacts JSX
    return(
        <table>

            
                {contacts.map(contactObj =>
                    <tr>
                        <td>{contactObj.id}</td>
                        <td>{contactObj.first_name}</td>
                        <td>Email- {contactObj.email}</td>
                        
                    </tr>
                )}
           
        </table>
    );
}